/**
 * @file PaddlePaddleFoundathon Hooks
 * @author v_duzhengqiang
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { fetchGetPaddleInfo } from '../../api/pages/paddleApi';
import {
    RootObject
} from './type';


const PaddlePaddleFoundathonHook = () => {
    // Banner
    const [banner, setBanner] = useState<RootObject["Banner"]>({
        backImg: '',
        headeImg: '',
        txtImg: '',
        content: [],
        lSymbolImg: '',
        rSymbolImg: '',
        descTxt: ''
    });
    // 专属权益
    const [exclusiveInterest, setExclusiveInterest] = useState<RootObject["exclusiveInterest"]>({
        zhTitle: '',
        enTitle: '',
        content: []
    });
    // 赛道介绍
    const [trackIntroduction, setTrackIntroduction] = useState<RootObject["trackIntroduction"]>({
        zhTitle: '',
        enTitle: '',
        content: []
    });
    // 时间安排
    const [timeArrangement, setTimeArrangement] = useState<RootObject["timeArrangement"]>({
        bFrameImf: '',
        zhTitle: '',
        enTitle: '',
        titleImg: '',
        title: '',
        content: []
    });
    // 活动奖项
    const [eventAward, setEventAward] = useState<RootObject["eventAward"]>({
        bFrameImf: '',
        zhTitle: '',
        enTitle: '',
        content: [],
        introTitle: '',
        introDesc: '',
    });
    // 相关咨询
    const [activityRule, setActivityRule] = useState<RootObject["activityRule"]>({
        zhTitle: '',
        enTitle: '',
        content: []
    });
    // 评审纬度
    const [reviewDimension, setReviewDimension] = useState<RootObject["reviewDimension"]>({
        zhTitle: '',
        enTitle: '',
        content: []
    });
    // 活动直播
    const [liveEvent, setLiveEvent] = useState<RootObject["liveEvent"]>({
        zhTitle: '',
        enTitle: '',
        content: []
    });
    // 专家评审
    const [expertReview, setExpertReview] = useState<RootObject["expertReview"]>({
        zhTitle: '',
        enTitle: '',
        backImg: '',
        content: []
    });
    // 专家评审
    const [partner, setPartner] = useState<RootObject["partner"]>({
        zhTitle: '',
        enTitle: '',
        content: []
    });
    // 专家评审
    const [publicity, setPublicity] = useState<RootObject["publicity"]>({
        inWai: {
            title: '',
            content: []
        },
        winAPprize: {
            title: '',
            content: []
        }
    });
    useMount(() => {
        (async () => {
            const res = await fetchGetPaddleInfo({ requestUrl: '/PaddlePaddleFoundathon-2023-8' })
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};


                data.Banner && setBanner(data.Banner);
                data.exclusiveInterest && setExclusiveInterest(data.exclusiveInterest);
                data.trackIntroduction && setTrackIntroduction(data.trackIntroduction);
                data.timeArrangement && setTimeArrangement(data.timeArrangement);
                data.eventAward && setEventAward(data.eventAward);
                data.activityRule && setActivityRule(data.activityRule);
                data.reviewDimension && setReviewDimension(data.reviewDimension);
                data.liveEvent && setLiveEvent(data.liveEvent);
                data.expertReview && setExpertReview(data.expertReview);
                data.partner && setPartner(data.partner);
                data.publicity && setPublicity(data.publicity);
            }
        })();
    });
    return {
        banner,
        exclusiveInterest,
        trackIntroduction,
        timeArrangement,
        eventAward,
        activityRule,
        reviewDimension,
        liveEvent,
        expertReview,
        partner,
        publicity
    }
}

export default PaddlePaddleFoundathonHook;